import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { ContentsService } from 'src/app/core/services/contents.service';
import { MyInterestService } from 'src/app/core/services/my-interest.service';
import { PlansService } from 'src/app/core/services/plans.service';
import { PrivateLibraryPackageService } from 'src/app/core/services/private-library-package.service';
import { environment } from 'src/environments/environment';
import { AudioNotPublishedComponent } from '../../all-modals/audio-not-published/audio-not-published.component';
import { AudioPublishedComponent } from '../../all-modals/audio-published/audio-published.component';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { PublicationNotPublishedComponent } from '../../all-modals/publication-not-published/publication-not-published.component';
import { PublicationPublishedComponent } from '../../all-modals/publication-published/publication-published.component';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { VideoNotPublishedComponent } from '../../all-modals/video-not-published/video-not-published.component';
import { VideoPublishedComponent } from '../../all-modals/video-published/video-published.component';
import { CreatePackageModalComponent } from '../create-package-modal/create-package-modal.component';
import { AuthService } from './../../../core/services/auth.service';
import { FormGroup, FormBuilder, Validators, FormArray, ValidationErrors } from '@angular/forms';
import { CancelSubscriptionComponent } from '../../subscription-plans/cancel-subscription/cancel-subscription.component';
import { UploadSpaceModalComponent } from '../../wipod/upload-publication/upload-space-modal/upload-space-modal.component';
import { SelectAudioPlaylistItemsModalComponent } from '../select-audio-playlist-items-modal/select-audio-playlist-items-modal.component';
import { PrivateLibraryService } from 'src/app/core/services/private-library.service';
import { TemplateBindingParseResult } from '@angular/compiler';

@Component({
  selector: 'app-publish-modal',
  templateUrl: './publish-modal.component.html',
  styleUrls: ['./publish-modal.component.scss']
})
export class PublishModalComponent implements OnInit {
  @Input() publishData;

  submitted: boolean = false;
  myInterest = [];
  imgURL: any;
  dropdownList = [];
  selectedItems = [];
  selectedMaterial = [];
  materialTypeList = [];
  taggedInterestCopy = [];
  taggedInterestAttribute = [];
  tokens: any = 0;
  duration: any = '';
  taggedInterestOfUser: any;
  textAreaLength = 0;
  myInterestTaggedData: any;
  adult_content: boolean;

  dropdownSettings = {
    singleSelection: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    enableFilterSelectAll: true,
    noDataLabel: "No genere found",
    classes: "myclass custom-class",
    text: 'Select genres',
    limitSelection: 5
  };

  dropdownMaterialSettings = {
    singleSelection: true,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    enableFilterSelectAll: false,
    noDataLabel: "No material type found",
    classes: "myclass custom-class",
    text: 'Select material type'
  };

  errorMessage: string;
  isError: boolean = false;
  year = '';
  month = '';
  playlist: any;

  publishform = {
    outline: '',
    description: '',
    selectedItems: [],
    tokens: 0,
    duration_number: 1,
    duration_number_for_bulk: 1,
    duration_units: '',
    duration_units_for_bulk: '',
    material_id: '',
    adult_content: true,
    is_downloadable: false,
    content_prices_attributes: this.formBuilder.array([]),
    no_of_clicks: undefined
  }
  publishForm: FormGroup;
  imagePath: string;
  activePlan: any;
  paidPlan: boolean;
  deSelectedArray: any;
  stopPublishCollection = '';
  isSupplementaryUser: boolean;
  currentUser: any;
  descPattern = false;
  outlineError = false;
  bulkDiscountEnabled: boolean = false;
  showAboveField: boolean = false;
  addMorePriceFlag: any = [];
  aboveValue;
  aboveTokenValue;
  aboveValueLimit = 300;
  content_price_ranges_limit: number = 5;
  isFormValid: boolean = true;

  priceFormArray(i?) { return this.publishform.content_prices_attributes as FormArray; }

  constructor(private activeModal: NgbActiveModal,
    private _myInterestService: MyInterestService,
    private _spinner: NgxSpinnerService,
    private _contentsService: ContentsService,
    private modalService: NgbModal,
    private _packageService: PrivateLibraryPackageService,
    private _privateLibraryService: PrivateLibraryService,
    private _plansService: PlansService,
    private _authService: AuthService,
    private formBuilder: FormBuilder) {
  }

  ngOnInit() {

    this.currentUser = this._authService.getCurrentUser();
    this.getActivePlan();
    this.getUserData();
    this.publishForm = this.formBuilder.group({
      genre: ['']
    });
    this.isSupplementaryUser = this._authService.isSupplementaryAccount();

    if (this.publishData.duration_units == null) {
      this.publishData.duration_units = '';
    }
    if(this.publishData.duration_units_for_bulk == null) {
      this.publishData.duration_units_for_bulk= '';
    }
    this.imagePath = environment.url;
    this.selectedMaterial.push({
      id: this.publishData.material ? this.publishData.material.material_id : '',
      material_text: this.publishData.material ? this.publishData.material.material_text : '',
      itemName: this.publishData.material ? this.publishData.material.material_text : ''
    });

    this.publishform = {
      outline: this.publishData.out_line,
      description: this.publishData.description,
      selectedItems: [],
      tokens: this.publishData.tokens,
      duration_number: this.publishData.duration_number,
      duration_number_for_bulk: this.publishData.duration_number_for_bulk,
      duration_units: this.publishData.duration_units,
      duration_units_for_bulk: this.publishData.duration_units_for_bulk,
      adult_content: this.publishData.adult_content,
      material_id: this.publishData.material ? this.publishData.material['material_id'] : '',
      is_downloadable: this.publishData.is_downloadable,
      content_prices_attributes: this.formBuilder.array([]),
      no_of_clicks: (this.publishData.content_relationship && this.publishData.content_relationship.no_of_clicks) ? this.publishData.content_relationship.no_of_clicks : 0
    }

    if (this.publishData.content_prices && this.publishData.content_prices.length > 0 && this.publishData.bulk_content_duration !== null) {
      this.bulkDiscountEnabled = true;
      if (this.publishData.content_prices.length > 1) {
        this.showAboveField = true;

        for (let index = 0; index < this.publishData.content_prices.length - 1; index++) {
          let obj = this.formBuilder.group({
            min_qty: [+this.publishData.content_prices[index].min_qty, Validators.compose([Validators.required, Validators.min(1), Validators.max(this.aboveValueLimit)])],
            max_qty: [+this.publishData.content_prices[index].max_qty, Validators.compose([Validators.required, Validators.min(2), Validators.max(this.aboveValueLimit)])],
            tokens: [+this.publishData.content_prices[index].tokens, Validators.compose([Validators.required, Validators.min(1)])],
            id: [+this.publishData.content_prices[index].id]
          }, {
            validator: this.maxValueValidator('min_qty', 'max_qty')
          });
          this.priceFormArray().push(obj);
          this.priceFormArray().controls[index].disable();
          let addPriceRange =
          {
            priceFlag: true
          }
          this.addMorePriceFlag.push(addPriceRange);
        }

        let addPriceRange =
        {
          priceFlag: false
        }
        this.addMorePriceFlag.push(addPriceRange);

        this.aboveValue = this.publishData.content_prices[this.publishData.content_prices.length - 1].min_qty;
        this.aboveTokenValue = this.publishData.content_prices[this.publishData.content_prices.length - 1].tokens;

      }
      else {
        this.showAboveField = false;

        for (let index = 0; index < this.publishData.content_prices.length; index++) {
          let obj = this.formBuilder.group({
            min_qty: [+this.publishData.content_prices[index].min_qty, Validators.compose([Validators.required, Validators.min(1), Validators.max(this.aboveValueLimit)])],
            max_qty: [+this.publishData.content_prices[index].max_qty, Validators.compose([Validators.required, Validators.min(2), Validators.max(this.aboveValueLimit)])],
            tokens: [+this.publishData.content_prices[index].tokens, Validators.compose([Validators.required, Validators.min(1)])],
            id: [+this.publishData.content_prices[index].id]
          }, {
            validator: this.maxValueValidator('min_qty', 'max_qty')
          });
          this.priceFormArray().push(obj);

          let addPriceRange =
          {
            priceFlag: true
          }
          this.addMorePriceFlag.push(addPriceRange);
        }

        let addPriceRange =
        {
          priceFlag: false
        }
        this.addMorePriceFlag.push(addPriceRange);

      }

      if (this.publishData.content_prices.length > 1) {
        this.priceFormArray().controls[this.publishData.content_prices.length - 2].enable();
      }
      //

    }
    this.textAreaLength = (this.publishData.description) ? this.publishData.description.length : 0;
    if (this.publishData.collection_type === 'content') {
      // check for the type of content
      this._contentsService.getMaterialType().subscribe((response: any) => {
        switch (this.publishData.content_type) {
          case 'document': this.materialTypeList = response.data['publications']; break;
          case 'audio': this.materialTypeList = response.data['audios']; break;
          case 'video': this.materialTypeList = response.data['videos']; break;

        }

        if (this.materialTypeList && this.materialTypeList.length) {
          this.materialTypeList.map(val => {
            val.itemName = val.material_text;
          });
        }
      });

      this._myInterestService.getMyInterest("?content_type=" + this.publishData.content_type).subscribe((response: any) => {
        // this.dropdownList = response.data.interests;
        let dropdownList = response.data.interests;

        dropdownList.forEach(element => {
          if (this.publishData.content_type == element.content_type)
            this.dropdownList.push(element);
        });


        if (this.dropdownList && this.dropdownList.length) {
          this.dropdownList.map(val => {
            val.itemName = val.title;
          });

          if (this.dropdownList && this.dropdownList.length && this.publishData.tagged_interests) {
            this.dropdownList.forEach((element) => {
              this.publishData.tagged_interests.forEach((elementInterest) => {
                if (element.id === elementInterest.interest_id) {
                  element['autoGeneratedId'] = elementInterest.id;
                  this.selectedItems.push(element);
                }
              });
            });
            this.publishForm.controls.genre.setValue(this.selectedItems);
            this.taggedInterestCopy = this.selectedItems;
            if (this.dropdownList.length == this.selectedItems.length) {
              this.onSelectAll(this.selectedItems)
            }
          }
        }

        for (const data of this.dropdownList) {
          if (this.publishData.tagged_interests && this.publishData.tagged_interests.length) {
            if (this.publishData.tagged_interests.indexOf(data.id) > -1) {
              this.publishform.selectedItems.push(data);
            }
          }
        }
      });

      const taggedInterestsAttributes = [];
      this.selectedItems.forEach(element => {
        taggedInterestsAttributes.push({
          interest_id: element.id
        })
      });
      if(this.publishData.thumbnail_variants){
        this.imgURL = this.publishData.thumbnail_variants.aud_tmb;
      } else if (this.publishData.thumb) {
        this.imgURL = this.imagePath + this.publishData.thumb
      }
      else {
        if (this.publishData.content_type === 'document') {
          this.imgURL = '../../assets/images/icons/publication-primary-default-card-icon.jpg';
        }
        else if (this.publishData.content_type === 'video') {
          this.imgURL = '../../assets/images/icons/video-primary-default-card-icon.jpg';
        }
        else if (this.publishData.content_type === 'audio') {
          this.imgURL = '../../assets/images/icons/audio-primary-default-card-icon.jpg';
        }
      }
    }
    if (this.publishData.collection_type != 'content') {

      if(this.publishData.thumbnail_grayed){
        this.imgURL = this.publishData.thumbnail_grayed;
      } else if(this.publishData.thumbnail_variants){
        this.imgURL = this.publishData.thumbnail_variants.aud_tmb;
      } else if (this.publishData.thumbnail) {
        this.imgURL = this.imagePath + (this.publishData.thumbnail_grayed) ? this.publishData.thumbnail_grayed : this.publishData.thumbnail;
      }
      this.checkCollactionForPublish();
    }
  }

  getUserData() {
    this._authService.getCurrentUserData(this.currentUser.user.id).subscribe(
      (response: any) => {
        if (response.success) {
          this.currentUser.user = response.data.user;
        }
      });
  }

  restrictNumeric(event) {
    //firefox solution
    event = event || window.event;
    var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
    var charStr = String.fromCharCode(charCode);

    if (!charStr.match(/^[0-9]+$/))
      event.preventDefault();

    const restrictKeycodes = [101, 46, 43, 45];
    if (restrictKeycodes.includes(event.keyCode) || event.target.value.length > 11) {
      return false;
    }
  }

  selectedInterestIdOfUser() {
    this._spinner.show();
    this._myInterestService.getTaggedInterestOfUser().subscribe((response: any) => {
      if (response.success) {
        this._spinner.hide();
        this.taggedInterestOfUser = response.data.tagged_interests;
        this.myInterest.map((val) => {
          val.isTagged = false;
        });

        this.myInterest.forEach(element => {
          if (response.data.tagged_interests.indexOf(element.id) > -1) {
            element.isTagged = true;
          }
        });
        this.myInterestTaggedData = this.myInterest.filter((val) => {
          return val.isTagged === true;
        });
      }
    })
  }

  onItemSelect(item: any) {
    const selectInterest = {
      interest_id: item.id
    }
    const index = this.taggedInterestAttribute.findIndex(val => val.interest_id === item.id);
    if (index === -1) {
      this.taggedInterestAttribute.push(selectInterest)
    }
    this.taggedInterestCopy = [...this.taggedInterestAttribute];


  }

  OnItemDeSelect(item: any) {
    if (this.deSelectedArray && this.deSelectedArray.length) {
      this.deSelectedArray.push(item);
    }
    if (item.autoGeneratedId) {
      const deSelectInterest = {
        id: item.autoGeneratedId,
        _destroy: true
      }
      const index = this.taggedInterestAttribute.findIndex(val => val.id === item.autoGeneratedId);
      if (index === -1) {
        this.taggedInterestAttribute.push(deSelectInterest);
      }
      else {
        let tempIndex = this.taggedInterestAttribute.findIndex(val => val.interest_id === item.id);
        this.taggedInterestAttribute.splice(tempIndex, 1);
      }
    } else {
      const index = this.taggedInterestAttribute.findIndex(val => val.interest_id === item.id);
      if (index > -1) {
        this.taggedInterestAttribute.splice(index, 1);
      }
    }
    this.taggedInterestCopy = this.selectedItems;
  }

  onFilterSelectDeselectAll(items: any, value: string) {
    let taggedInterestsArray = [];
    if (value === 'deselect') {
      if (items && items.length) {
        items.forEach((ele) => {
          const obj = {
            id: ele.autoGeneratedId,
            _destroy: true
          };
          taggedInterestsArray.push(obj);
        });

      }
    }

    if (this.selectedItems && this.selectedItems.length) {
      const addedSelectedArray = this.selectedItems.filter((val) => {
        return val.hasOwnProperty('autoGeneratedId');
      });
      addedSelectedArray.forEach((ele) => {
        const obj = {
          id: ele.autoGeneratedId,
          _destroy: true
        };
        taggedInterestsArray.push(obj);
      });
    }

    if (this.deSelectedArray && this.deSelectedArray.length) {
      const deletedArray = this.deSelectedArray.filter((val) => {
        return val.hasOwnProperty('autoGeneratedId');
      });

      deletedArray.forEach((element) => {
        const obj = {
          id: element.autoGeneratedId,
          _destroy: true
        };
        taggedInterestsArray.push(obj);
      });
    }
    if (this.selectedItems && this.selectedItems.length) {
      this.selectedItems.forEach((element) => {
        const obj = {
          interest_id: element.id
        };
        taggedInterestsArray.push(obj);
      });

    }
    this.taggedInterestAttribute = JSON.parse(JSON.stringify(taggedInterestsArray));
    this.taggedInterestCopy = JSON.parse(JSON.stringify(taggedInterestsArray));
  }

  onSelectAll(items: any) {

    if (this.publishData) {

      this.selectedItems.forEach(item => {
        if (item.autoGeneratedId) {
          const deSelectInterest = {
            id: item.autoGeneratedId,
            _destroy: true
          }
          this.taggedInterestAttribute.push(deSelectInterest);
        }
      })

      this.selectedItems = []
      items.forEach(item => {
        const selectInterest = {
          interest_id: item.id
        }
        this.selectedItems.push(item)
        // const index1 = this.selectedItems.findIndex(val => val.interest_id === item.id)
        const index = this.taggedInterestAttribute.findIndex(val => val.interest_id === item.id);
        if (index === -1) {
          this.taggedInterestAttribute.push(selectInterest)
        }
      });
      this.taggedInterestCopy = this.selectedItems
    }
  }

  onDeSelectAll(items: any) {

    if (this.publishData) {
      this.taggedInterestAttribute = [];
      this.dropdownList.forEach(item => {
        if (item.autoGeneratedId) {
          const deSelectInterest = {
            id: item.autoGeneratedId,
            _destroy: true
          }
          const index = this.taggedInterestAttribute.findIndex(val => val.id === item.autoGeneratedId);
          if (index === -1) {
            this.taggedInterestAttribute.push(deSelectInterest);
          }
          else {
            let tempIndex = this.taggedInterestAttribute.findIndex(val => val.interest_id === item.id);
            this.taggedInterestAttribute.splice(tempIndex, 1);
          }

        } else {
          const index = this.taggedInterestAttribute.findIndex(val => val.interest_id === item.id);
          // const array = [];
          if (index > -1) {
            this.taggedInterestAttribute.splice(index, 1);
          }
          // this.taggedInterestAttribute = [...array];
        }
      })
      this.taggedInterestCopy = this.selectedItems
    }
  }

  onMaterialSelect(item: any) {
  }
  OnMaterialDeSelect(item: any) {
  }
  onMaterialDeSelectAll(items: any) {
  }

  restrictNumericPaste(event) {
    let text = event.clipboardData.getData('text').toString();
    let filteredText = text.replace(REGEX_PATTERNS.NUMBER_REMOVE, "");

    if (event.target.name == 'duration_number') {
      this.publishform.duration_number = this.publishform.duration_number ? (this.publishform.duration_number.toString() + filteredText) : filteredText;
      this.publishform.duration_number = (+this.publishform.duration_number.toString().substring(0, 12));
    }
    else if (event.target.name == 'duration_number_for_bulk') {
      this.publishform.duration_number_for_bulk = this.publishform.duration_number_for_bulk ? (this.publishform.duration_number_for_bulk.toString() + filteredText) : filteredText;
      this.publishform.duration_number_for_bulk = (+this.publishform.duration_number_for_bulk.toString().substring(0,12));
    }
    else if (event.target.name == 'tokens') {
      this.publishform.tokens = this.publishform.tokens ? (this.publishform.tokens.toString() + filteredText) : filteredText;
      this.publishform.tokens = (+this.publishform.tokens.toString().substring(0, 12));
    }
    else if (event.target.name == 'no_of_clicks') {

      this.publishform.no_of_clicks = this.publishform.no_of_clicks ? (this.publishform.no_of_clicks.toString() + filteredText) : filteredText;

      if (this.publishform.no_of_clicks) {
        this.publishform.no_of_clicks = (+this.publishform.no_of_clicks.toString().substring(0, 12));
      }
    }
    event.preventDefault();
  }

  restrictNumericPasteNew(event, priceIndex?, controlName?) {
    let text = event.clipboardData.getData('text').toString();
    let filteredText = text.replace(REGEX_PATTERNS.NUMBER_REMOVE, "");

    // if (event.target.id == 'clicks') {
    //   let no_of_clicks = (this.contentFormArray.controls[formIndex]['controls'].no_of_clicks.value) ? (this.contentFormArray.controls[formIndex]['controls'].no_of_clicks.value.toString() + filteredText) : filteredText

    //   this.contentFormArray.controls[formIndex].patchValue({
    //     no_of_clicks: no_of_clicks.substring(0, 12)
    //   });
    // }
    if (controlName == 'max_qty') {
      let max_qty = (this.priceFormArray().controls[priceIndex]['controls'].max_qty.value) ? (this.priceFormArray().controls[priceIndex]['controls'].max_qty.value.toString() + filteredText) : filteredText
      this.priceFormArray().controls[priceIndex].patchValue({
        max_qty: max_qty.substring(0, 12)
      });
    }
    else if (controlName == 'min_qty') {
      let min_qty = (this.priceFormArray().controls[priceIndex]['controls'].min_qty.value) ? (this.priceFormArray().controls[priceIndex]['controls'].min_qty.value.toString() + filteredText) : filteredText
      this.priceFormArray().controls[priceIndex].patchValue({
        min_qty: min_qty.substring(0, 12)
      });
    }
    else if (controlName == 'tokens') {
      let token = (this.priceFormArray().controls[priceIndex]['controls'].tokens.value) ? (this.priceFormArray().controls[priceIndex]['controls'].tokens.value.toString() + filteredText) : filteredText
      this.priceFormArray().controls[priceIndex].patchValue({
        tokens: token.substring(0, 12)
      });
    }
    else if (controlName == 'aboveToken') {
      let aboveValue = this.aboveTokenValue ? (this.aboveTokenValue.toString() + filteredText) : filteredText
      this.aboveTokenValue = aboveValue.substring(0, 12)
    }
    event.preventDefault();
  }

  findDot(event) {
    if (event.keyCode == 46) {
      event.preventDefault();
    }
  }

  onPublish(data?) {

    this.descPattern = false;
    this.outlineError = false;

    if (this.publishData.tokens > 0) {
      if ((this.currentUser.user.verification == null || this.currentUser.user.verification.is_verified == 'rejected') && this.publishData.collection_type != 'normal') {

        if (this.currentUser.user.verification && this.currentUser.user.verification.is_verified == 'rejected') {
          const modalRef = this.modalService.open(CancelSubscriptionComponent, { centered: true });
          modalRef.componentInstance.forStatus = 'content-upload';
          modalRef.result.then((result) => {
            if (result)
              this.ngOnInit();
          });
          return;
        }
        else {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.VERIFICATION_PENDING_PAID_CONTENT_UPLOAD;
          return;
        }
      }

      // if (this.publishData.collection_type === 'normal' && this.currentUser.user.id != this.publishData.displayable_user_details.id && !this.publishData.is_creator_verified) {
      //   const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
      //   if (this.publishData.collection_type === 'special') {
      //     modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.VERIFICATION_REJECTED_OWNER_COLLECTION.replace('<collection>', 'package');
      //   } else {
      //     modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.VERIFICATION_REJECTED_OWNER_COLLECTION.replace('<collection>', 'playlist');
      //   }
      //   return;
      // }
    }

    this.submitted = true;
    if (this.publishData.collection_type === 'normal') {
      if (this.publishform.outline && !this.publishform.outline.match(/^(?=.*?[a-zA-Z]).+$/)) {
        this.outlineError = true;
        return;
      }
      if (!this.publishform.outline) {
        return;
      }
    }

    if (this.publishData.collection_type === 'special') {
      if (this.publishform.outline && !this.publishform.outline.match(/^(?=.*?[a-zA-Z]).+$/)) {
        this.outlineError = true;
        return;
      }
      if (!this.publishform.outline) {
        return;
      }
      if ((!this.publishform.tokens && this.publishData.tokens > 0) || (this.publishform.tokens > 0 && this.publishData.tokens == null)) {
        return;
      }
      if (this.publishData.tokens > 0 && this.publishform.tokens <= 0)
        return;
    }

    if (this.publishData.collection_type === 'content') {
      if (this.publishform.description && !this.publishform.description.match(REGEX_PATTERNS.TEXT_AREA)) {
        this.descPattern = true;
        return;
      }
      if (this.publishform.outline && !this.publishform.outline.match(/^(?=.*?[a-zA-Z]).+$/)) {
        this.outlineError = true;
        return;
      }
      if (!this.publishform.outline || !this.publishform.description || !this.selectedItems.length) {
        return
      }
      if (this.selectedMaterial.length == 0)
        return;
      if (this.publishData.tokens > 0 && this.publishData.bulk_content_duration !== null) {
        if (this.publishform.tokens <= 0)
          return;
        if ((this.publishform.duration_units || this.publishform.duration_units_for_bulk) === 'weeks' && (this.publishform.duration_number || this.publishform.duration_number_for_bulk) > 4)
          return;

        if ((this.publishform.duration_units || this.publishform.duration_units_for_bulk) === 'months' && (this.publishform.duration_number || this.publishform.duration_number_for_bulk) > 12)
          return;

        if ((this.publishform.duration_units || this.publishform.duration_units_for_bulk) === 'days' && (this.publishform.duration_number || this.publishform.duration_number_for_bulk) > 7)
          return;

        if ((!this.publishform.duration_number || this.publishform.duration_number == 0) || (!this.publishform.duration_number_for_bulk || this.publishform.duration_number_for_bulk == 0))
          return;

        if (this.paidPlan && this.activePlan.plan.can_bulk_consume) {
          if ((+this.publishform.no_of_clicks) < 0 || this.publishform.no_of_clicks === '' || this.publishform.no_of_clicks == undefined) {
            return;
          }
        }
        if (this.bulkDiscountEnabled && (((!this.aboveTokenValue || this.aboveTokenValue <= 0) && this.showAboveField) || this.priceFormArray().invalid)) {
          return
        }
        if (!this.isFormValid)
          return
      }

    }

    this._spinner.show();

    let obj;

    if (this.publishData.collection_type === 'normal') {
      obj = {
        "content_collection": {
          name: this.publishform.outline.trim()
        }
      }
      this._packageService.publishPackage(obj, this.publishData.id).subscribe((response: any) => {
        this._spinner.hide()
        if (response.success) {
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.PUBLISH_PLAYLIST;
          modelRef.result.then((result) => {
            this.activeModal.close(true);
          }, (error) => {
            this.activeModal.close(true);
          });
          return;
        } else if (response.status == 444) {
          const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modelRef.componentInstance.message = response.errors;
          return;
        } else if (response.errors) {
          const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
          modalRef.componentInstance.contentAccessError = response.errors;
          modalRef.componentInstance.isRedirectRequired = false;
        }
        else if (response.success == false) {
          const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modelRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.CHOOSE_THE_SUBSCRIPTION_PLAN;
          return;
        }
        else {
          const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modelRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.PUBLISH_PLAYLIST;
          this.isError = true;
          return;
        }
      }, (error: any) => {
        this._spinner.hide();
        const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modelRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.PUBLISH_PLAYLIST;
        return;
        // this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      })
    }
    if (this.publishData.collection_type === 'special') {
      obj = {
        "content_collection": {
          name: this.publishform.outline.trim(),
          tokens: this.publishform.tokens
        }
      }
      this._packageService.publishPackage(obj, this.publishData.id).subscribe((response: any) => {
        this._spinner.hide()
        if (response.success) {
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.PUBLISH_PACKAGE;
          modelRef.result.then((result) => {
            this.activeModal.close(true);
          }, (error) => {
            this.activeModal.close(true);
          });
          return;
          // this._toastr.success(LITERALS.AUTH.SUCCESS_MESSAGES.PUBLISH_PRIVATE_TO_PUBLIC)
        }
        else if (response.status === 403) {
          if (response.data && response.data.current_user_id === response.data.collection_user_id) {
            const modalRef = this.modalService.open(CancelSubscriptionComponent, { centered: true });
            modalRef.componentInstance.forStatus = 'share-content';
            modalRef.componentInstance.errorMessage = response.errors;
          } else {
            const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
            modalRef.componentInstance.contentAccessError = response.errors;
            modalRef.componentInstance.isRedirectRequired = false;
          }
        }
        else if (response.errors) {
          const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
          modalRef.componentInstance.contentAccessError = response.errors;
          modalRef.componentInstance.isRedirectRequired = false;
        }
        else if (response.success == false) {
          const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modelRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.CHOOSE_THE_SUBSCRIPTION_PLAN;
          return;
        }
        else {
          const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modelRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.PUBLISH_PACKAGE;
          this.isError = true;
          return;
        }
      }, (error: any) => {
        this._spinner.hide();
        const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modelRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.PUBLISH_PACKAGE;
        return;
        // this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      })
    }
    if (this.publishData.collection_type === 'content') {
      obj = {
        content: {
          tokens: this.publishform.tokens,
          duration: this.publishform.duration_number + ' ' + this.publishform.duration_units,
          duration_bulk: this.publishform.duration_number_for_bulk ? this.publishform.duration_number_for_bulk + ' ' + this.publishform.duration_units_for_bulk : null,
          is_downloadable: this.publishform.is_downloadable,
          out_line: this.publishform.outline,
          description: this.publishform.description,
          material_id: this.selectedMaterial[0]['id'],
          adult_content: this.publishform.adult_content,
          //adult_content: true,
          tagged_interests_attributes: [...this.taggedInterestAttribute]
        }
      }
      if (this.paidPlan && this.activePlan.plan.can_bulk_consume) {
        obj['content']['no_of_clicks'] = this.publishform.no_of_clicks;
      }
      if (this.priceFormArray().getRawValue() && this.bulkDiscountEnabled) {

        let getRangeValues = this.priceFormArray().getRawValue();
        if (this.showAboveField) {
          let abovePriceRange = {
            min_qty: this.aboveValue,
            max_qty: this.aboveValueLimit,
            tokens: this.aboveTokenValue
          }
          getRangeValues.push(abovePriceRange);
        }

        if (getRangeValues.length >= this.publishData.content_prices.length) {

          getRangeValues.map((item, index) => {
            if (this.publishData.content_prices[index]) {
              item.id = this.publishData.content_prices[index].id
            }
          })
        }
        else if (getRangeValues.length < this.publishData.content_prices.length) {
          this.publishData.content_prices.map((item, index) => {
            if (getRangeValues[index]) {
              getRangeValues[index].id = item.id
            }
            else {
              let obj = {
                id: item.id,
                _destroy: true
              }
              getRangeValues.push(obj);
            }
          })
        }

        obj['content']['content_prices_attributes'] = getRangeValues;
        // obj['content']['max_value_for_price_range'] = this.aboveValueLimit;
        // obj['content']['price_range_limit'] = this.content_price_ranges_limit;

      } else if (!this.bulkDiscountEnabled[0] && this.publishData.content_prices.length > 0) {
        let getRangeValues = [];
        this.publishData.content_prices.map((item) => {
          let obj = {
            id: item.id,
            _destroy: true
          }
          getRangeValues.push(obj);
        });
        obj['content']['content_prices_attributes'] = getRangeValues;
      }
      this._contentsService.privateToPublic(obj, this.publishData.id).subscribe((response: any) => {
        this._spinner.hide()
        if (response.success) {
          this.closeDialog(true);
          if (this.publishData.content_type == 'document') {
            const modelRef = this.modalService.open(PublicationPublishedComponent, { centered: true });
            if (response.message == "Awaiting for approval") {
              modelRef.componentInstance.message = "Your material will be published to your public library once it is approved by your parent. You can check the status into your private library.";
              modelRef.componentInstance.title = "Success";
            }
            // Awaiting for approval
            return;
          }
          if (this.publishData.content_type == 'video') {
            const modelRef = this.modalService.open(VideoPublishedComponent, { centered: true });
            if (response.message == "Awaiting for approval") {
              modelRef.componentInstance.message = "Your material will be published to your public library once it is approved by your parent. You can check the status into your private library.";
              modelRef.componentInstance.title = "Success";
            }
            return;
          }
          if (this.publishData.content_type == 'audio') {
            const modelRef = this.modalService.open(AudioPublishedComponent, { centered: true });
            if (response.message == "Awaiting for approval") {
              modelRef.componentInstance.message = "Your material will be published to your public library once it is approved by your parent. You can check the status into your private library.";
              modelRef.componentInstance.title = "Success";
            }
            return;
          }
        }
        else if (response.errors == 'Validation failed: You are not allowed to create/publish material. Please contact your parent.') {
          const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
          modalRef.componentInstance.contentAccessError = LITERALS.AUTH.ERROR_MESSAGES.SUPP_NOT_ALLOWED_CRETE_PUBLISH;
          modalRef.componentInstance.isRedirectRequired = false;
        }
        else if (response.errors && response.status == 403) {
          const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
          modalRef.componentInstance.contentAccessError = response.errors;
          modalRef.componentInstance.isRedirectRequired = false;
        } else if (response.errors) {
          const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
          modalRef.componentInstance.contentAccessError = response.errors;
          modalRef.componentInstance.isRedirectRequired = false;
        }
        else if (response.success == false) {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.CHOOSE_THE_SUBSCRIPTION_PLAN;
        }
        else {
          // this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
          if (this.publishData.content_type == 'document') {
            this.modalService.open(PublicationNotPublishedComponent, { centered: true });
            return;
          }
          if (this.publishData.content_type == 'video') {
            this.modalService.open(VideoNotPublishedComponent, { centered: true });
            return;
          }
          if (this.publishData.content_type == 'audio') {
            this.modalService.open(AudioNotPublishedComponent, { centered: true });
            return;
          }
          this.isError = true;
        }
      }, (error: any) => {
        // this._toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        this._spinner.hide();
        // this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
        if (this.publishData.content_type == 'document') {
          this.modalService.open(PublicationNotPublishedComponent, { centered: true });
          return;
        }
        if (this.publishData.content_type == 'video') {
          this.modalService.open(VideoNotPublishedComponent, { centered: true });
          return;
        }
        if (this.publishData.content_type == 'audio') {
          this.modalService.open(AudioNotPublishedComponent, { centered: true });
          return;
        }
      })
    }

  }

  closeDialog(status) {
    this.activeModal.close(status);
  }
  textAreaAdjust(event) {
    this.textAreaLength = event.target.value.length;
    if (event.target.value.length && !this.publishform.description.match(REGEX_PATTERNS.TEXT_AREA)) {
      this.descPattern = true;
    } else {
      this.descPattern = false;
    }
    // event.target.style.height = "1px";
    // event.target.style.height = (event.target.scrollHeight)+"px";
  }

  titleCheck(event) {
    if (event.target.value.length && !this.publishform.outline.match(/^(?=.*?[a-zA-Z]).+$/)) {
      this.outlineError = true;
    } else {
      this.outlineError = false;
    }
  }

  getActivePlan() {
    this._plansService.getActivePlan().subscribe((response: any) => {
      if (response.success) {
        this.activePlan = response.data.subscription[0];
        if (this.activePlan.plan && this.activePlan.plan.price > 0) {
          this.paidPlan = true;

          this.aboveValueLimit = (this.publishData && this.publishData.max_value_for_price_range > 0) ? this.publishData.max_value_for_price_range : this.activePlan.max_value_for_above_content_price;
          this.content_price_ranges_limit = (this.publishData && this.publishData.price_range_limit > 0) ? this.publishData.price_range_limit : this.activePlan.content_price_ranges_limit;

          // this.aboveValueLimit = this.activePlan.max_value_for_above_content_price;
          // this.content_price_ranges_limit = this.activePlan.content_price_ranges_limit;

          this.updateTimeMatrixValidation();
        } else if (this.currentUser.user && this.currentUser.user.last_plan && this.currentUser.user.last_plan.plan.price > 0 && this.publishData && this.publishData.tokens > 0) {
          this.paidPlan =  true;
        }
        else {
          this.paidPlan = false;
        }
      }
    })
  }

  updateTimeMatrixValidation() {
    if (this.publishData && this.publishData.content_prices && this.publishData.content_prices.length > 0) {

      let flag;
      if (this.showAboveField)
        flag = 1;
      else
        flag = 0;

      for (let indx = 0; indx < this.publishData.content_prices.length - flag; indx++) {
        this.priceFormArray().controls[indx]['controls']['min_qty'].setValidators(Validators.compose([Validators.required, Validators.min(1), Validators.max(this.aboveValueLimit)]));
        this.priceFormArray().controls[indx]['controls']['min_qty'].updateValueAndValidity();

        this.priceFormArray().controls[indx]['controls']['max_qty'].setValidators(Validators.compose([Validators.required, Validators.min(2), Validators.max(this.aboveValueLimit)]));
        this.priceFormArray().controls[indx]['controls']['max_qty'].updateValueAndValidity();

        if (this.priceFormArray().controls[indx]['controls']['min_qty'].errors && this.priceFormArray().controls[indx]['controls']['min_qty'].errors.max) {
          this.priceFormArray().controls[indx]['controls']['min_qty'].setErrors(null);
        }
      }
    }
  }

  checkCollactionForPublish() {
    this._spinner.show();
    this._packageService.checkCollectionForPublish(this.publishData.id).subscribe((response: any) => {
      this._spinner.hide();
      if (response && !response.success) {
        this.stopPublishCollection = response.errors;
      } else {
        this.stopPublishCollection = "";
      }
    }, (err) => this._spinner.hide());
  }

  editCollection() {
    if (this.publishData.collection_type === 'special') {
      const modalRef = this.modalService.open(CreatePackageModalComponent, { size: 'lg', centered: true });
      modalRef.componentInstance.packageObj = this.publishData;
      modalRef.componentInstance.editPackage = true;
      modalRef.result.then((result) => {
        if (result) {
          this.checkCollactionForPublish();
          this.contentcollection();
        }
      }, (reason) => {
      });
    } else if (this.publishData.collection_type === 'normal') {
      const modalRef = this.modalService.open(SelectAudioPlaylistItemsModalComponent, { centered: true });
      modalRef.componentInstance.editPlaylistObj = this.publishData;
      modalRef.componentInstance.data = this.publishData.content_type;
      modalRef.result.then((result) => {
        if (result) {
          this.checkCollactionForPublish();
          this.contentcollection();
        }
      }, (reason) => {
      });
    }
  }

  trimControl(control) {
    if (this.publishform[control]) {
      this.publishform[control] = this.publishform[control].trim();
    }
  }

  removeMorePrices(priceIndex) {
    this.priceFormArray().removeAt(priceIndex);
    this.addMorePriceFlag.pop();
    this.priceFormArray().controls[priceIndex - 1].enable();
    this.aboveValue = (this.priceFormArray().getRawValue()[(this.priceFormArray().getRawValue().length - 1)].max_qty > 0) ? (this.priceFormArray().getRawValue()[(this.priceFormArray().getRawValue().length - 1)].max_qty + 1) : (this.priceFormArray().getRawValue()[(this.priceFormArray().getRawValue().length - 2)].max_qty + 1);
    if (this.aboveValue > 0)
      this.showAboveField = true;
  }
  addMorePrices(priceIndex) {
    this.addMorePriceFlag[priceIndex].priceFlag = true;
    let price = this.priceFormArray().getRawValue();
    let obj;

    if (this.priceFormArray().invalid) {
      return;
    }

    //uncomment this in final build and from html line no :320
    // if (this.activePlan.content_price_ranges_limit > (this.priceFormArray().controls.length + 1)) {
    if (this.content_price_ranges_limit > (this.priceFormArray().controls.length + 1)) {

      obj = this.formBuilder.group({
        min_qty: [(price[priceIndex].max_qty + 1), Validators.compose([Validators.required, Validators.min(1), Validators.max(this.aboveValueLimit)])],
        max_qty: [null, Validators.compose([Validators.required, Validators.min(2), Validators.max(this.aboveValueLimit)])],
        tokens: [null, Validators.compose([Validators.required, Validators.min(1)])],
        id: ['']
      }, {
        validator: this.maxValueValidator('min_qty', 'max_qty')
      });
      this.priceFormArray().push(obj);
      this.priceFormArray().controls[priceIndex].disable();
      this.showAboveField = false;
      let addPriceRange =
      {
        priceFlag: false
      }
      this.addMorePriceFlag.push(addPriceRange);
      this.aboveTokenValue = '';
    }
    else {
      this.aboveValue = (this.priceFormArray().getRawValue()[(this.priceFormArray().getRawValue().length - 1)].max_qty > 0) ? (this.priceFormArray().getRawValue()[(this.priceFormArray().getRawValue().length - 1)].max_qty + 1) : (this.priceFormArray().getRawValue()[(this.priceFormArray().getRawValue().length - 2)].max_qty + 1);
      if (this.aboveValue > 0)
        this.showAboveField = true;
    }
  }

  public maxValueValidator(min_qty, max_qty): ValidationErrors | null {
    return (formGroup: FormGroup) => {
      const minQty = formGroup.controls[min_qty];
      const maxQty = formGroup.controls[max_qty];

      // if (minQty.errors && maxQty.errors) {
      //   return;
      // }

      let min_value = minQty.value;
      let max_value = maxQty.value;

      if (min_value == undefined)
        minQty.setErrors({ required: true });

      if (max_value == undefined)
        maxQty.setErrors({ required: true });

      if (min_value && max_value && min_value >= max_value) {
        maxQty.setErrors({ minValue: true });
      }
      else if (min_value && max_value && min_value < max_value && max_value <= this.aboveValueLimit) {
        maxQty.setErrors(null);
      }
      if (min_value && max_value && (min_value == max_value && max_value == this.aboveValueLimit)) {
        maxQty.setErrors(null);
      }
    }

  }
  getMaxValue(event) {
    if (event.target.value > 0 && event.target.value < this.aboveValueLimit) {
      this.showAboveField = true;
      this.aboveValue = (this.priceFormArray().getRawValue()[(this.priceFormArray().getRawValue().length - 1)].max_qty > 0) ? (this.priceFormArray().getRawValue()[(this.priceFormArray().getRawValue().length - 1)].max_qty + 1) : (this.priceFormArray().getRawValue()[(this.priceFormArray().getRawValue().length - 2)].max_qty + 1);
    }
    else {
      this.showAboveField = false;
    }
  }

  changebulkDiscount() {
    if (!this.bulkDiscountEnabled) {
      let obj = this.formBuilder.group({
        min_qty: [1, Validators.compose([Validators.required, Validators.min(1), Validators.max(this.aboveValueLimit)])],
        max_qty: [null, Validators.compose([Validators.required, Validators.min(2), Validators.max(this.aboveValueLimit)])],
        tokens: [null, Validators.compose([Validators.required, Validators.min(1)])],
        id: ['']
      }, {
        validator: this.maxValueValidator('min_qty', 'max_qty')
      });
      this.priceFormArray().push(obj);
      let addPriceRange = {
        priceFlag: false
      }
      this.addMorePriceFlag = [];
      this.addMorePriceFlag.push(addPriceRange);
    }
    else if (this.bulkDiscountEnabled) {
      this.aboveTokenValue = '';
      this.priceFormArray().clear();
      this.showAboveField = false;
    }

    this.bulkDiscountEnabled = !this.bulkDiscountEnabled;

  }

  contentcollection() {
    this._privateLibraryService.showPackage(this.publishData.id).subscribe((response: any) => {
      this._spinner.hide();
      if (response.success) {
        this.publishData = response.data.content_collection;
        if (this.publishData && this.publishData.contents) {
          this.publishData.contents.map(audio_contents => {
            let default_icon = '';
            if (audio_contents.content_type === 'audio') {
              default_icon = '../../assets/images/icons/audio-primary-default-card-icon.jpg';
            } else if (audio_contents.content_type === 'video') {
              default_icon = '../../assets/images/icons/video-primary-default-card-icon.jpg';
            } else if (audio_contents.content_type === 'document') {
              default_icon = '../../assets/images/icons/publication-primary-default-card-icon.jpg';
            }
            audio_contents.thumb = (audio_contents.thumb != '') ? this.imagePath + audio_contents.thumb : default_icon;
          });
        };
      }
    }, (error: any) => {
    })
  }

  isPriceValid(range, index) {
    if (index == 0 && range.get('min_qty').value > this.aboveValueLimit - 1) {
      this.isFormValid = false;
      return false;
    }
    else {
      this.isFormValid = true;
      return true;
    }
  }
}
